import { HostingTypeToQueryParam } from '@atlassian/mpac-types';
import { stringify } from 'query-string';
import { useEffect } from 'react';
import { AppListingTab } from "../../../../../constants";
export const makeReviewsTabLink = ({
  appListingLink,
  hosting,
  appId,
  slug
}) => {
  const baseUrl = appListingLink.expand({
    appId,
    slug,
    hosting: HostingTypeToQueryParam[hosting],
    tab: AppListingTab.Reviews
  });
  const searchParams = new URLSearchParams(window.location.search);
  const reviewId = searchParams.get('reviewId');
  const vote = searchParams.get('vote');
  const additionalQueryParams = {
    embeddedTab: 'true',
    ...(reviewId && vote && {
      reviewId,
      vote
    })
  };
  return [baseUrl, stringify(additionalQueryParams)].join('&');
};

const hasAccessToIframe = iframe => {
  try {
    const _ = iframe.contentWindow.location.origin;
    return true;
  } catch {
    return false;
  }
};

/**
 * The review iframe still lives in AMKT, and emits various events
 * to its parent frame when loaded in an embedded iframe.
 * These events can be used to detect load, pagination etc
 */
export const useReviewIframeEvents = (iframeRef, reviewsLink) => {
  let onIframeLoadStartedCallback = _ => {};

  let onIframeInitializedCallback = _ => {};

  let onMoreReviewsRenderedCallback = _ => {};

  let onIframeCORSErrorCallback = _ => {};

  const onIframeInitialized = callback => {
    onIframeInitializedCallback = callback;
  };

  const onMoreReviewsRendered = callback => {
    onMoreReviewsRenderedCallback = callback;
  };

  const onIframeLoadStarted = callback => {
    onIframeLoadStartedCallback = callback;
  };

  const onIframeCORSError = callback => {
    onIframeCORSErrorCallback = callback;
  };

  useEffect(() => {
    const {
      current: iframe
    } = iframeRef;

    if (!iframe) {
      return;
    }

    onIframeLoadStartedCallback(iframe);

    const listenToIframeEvents = ({
      origin,
      data
    }) => {
      if (!hasAccessToIframe(iframe)) {
        onIframeCORSErrorCallback();
        return;
      } // Only listen to message originating from the review's iframe


      if (!iframe.contentWindow.location.origin === origin) return;
      let parsedMessage;

      try {
        parsedMessage = JSON.parse(data);
      } catch {// Not all events are JSONs — we ignore non JSONs
      }

      if (!parsedMessage) return; // Ignore if the event payload doesn't match known signature

      if (!parsedMessage.type === 'app-listing-review-tab-event') {
        return;
      }

      switch (parsedMessage.message) {
        case 'initialized':
          onIframeInitializedCallback(iframe);
          break;

        case 'moreReviewsRendered':
          onMoreReviewsRenderedCallback(iframe);
          break;
      }
    };

    window.addEventListener('message', listenToIframeEvents, false);
    return () => {
      window.removeEventListener('message', listenToIframeEvents, false);
    };
  }, [reviewsLink]);
  return {
    onIframeLoadStarted,
    onIframeInitialized,
    onMoreReviewsRendered,
    onIframeCORSError
  };
};